import { gEnums } from "../../enums/globalEnums"

/**
 * List of actions that can be taking with a collection
 */
export const appCollectionActionTypes = {
  bulkImageUpload: 'bulkImageUpload',
  createCollectionData: 'createCollectionData',
  fixPropData: 'fixPropData',
  googleSheetsData: 'googleSheetsData',
  productionData: 'productionData',
  registrationData: 'registrationData',
  storageImages: 'storageImages',
  updateDataRelationships: 'updateDataRelationships',
}


/**
 * List of actions that can be taken with collection data
 * Anything call with these options will go to AppDataContent
 */
export const appDataActionTypes = {
  ammendPropData: 'ammendPropData', // > UiFixPropNames
  backupItemData: 'backupItemData', // > UiBackupData
  convertToParentKeys: 'convertToParentKeys',  // > UiParentKeys
  copyData: 'copyData', // > UiCopyPaste
  createAppDataLinks: 'createAppDataLinks', // > UiAppDataLinks
  createFilter: 'createFilter', // > UiDataFilters
  createGlobalData: 'createGlobalData', // > <UiCreateGlobalData />
  createNotification: 'createNotification', // > <CreateNotificationWizard />
  createSingleDocument: 'createSingleDocument', // > <UiConvertToDocument />
  fixData: 'fixData', // > <UiFixData />
  fixPropNames: 'fixPropNames', // > UiFixPropNames
  moveData: 'moveData',  // > UiMoveData
  moveDataTo: 'moveDataTo',  // > UiMoveData
  secretData: 'secretData', // > UiSecretData
  transferStorageFolder: 'transferStorageFolder', // > AppStorageTransferWithProvider
  updateParentKeys: 'updateParentKeys',  // > UiParentKeys
  updateStaticViews: 'updateStaticViews', // > <UiCreateGlobalData />
}

export const dataManagementTypes = {
  createNotification: 'createNotification',
  createTopic: 'createTopic',
  googleDataUpdate: 'googleDataUpdate',
  googleSheetLink: 'googleSheetLink',
  googleSheetUpdate: 'googleSheetUpdate',
  imageLinks: 'imageLinks',
  imageMapping: 'imageMapping',
  manageData: 'manageData',
  openDatabase: 'openDatabase',
  ...appCollectionActionTypes,
}

export const dats = {
  appDataActionTypes,
  appCollectionActionTypes,
}

export const dataModificationTypes = {
  add: 'add',
  modifyList: 'modifyList', // modifyList
  status: 'status', // status
  clipboard: 'clipboard',
  createList: 'createList',
  credentialing: 'credentialing',
  dataLinking: 'dataLinking', // dataLinking
  dataLinking_data: 'dataLinking_data',
  downloads: 'downloads',
  edit: 'edit',
  filters: 'filters',
  imageMapping: 'imageMapping',
  notification: 'notification',
  sorting: 'sorting',
  subAction: 'subAction',
  bulkImageUpload: 'bulkImageUpload', // bulkImageUpload
  images: 'images', // images
  pdfs: 'pdfs', // pdfs
  upload_storageImages: 'upload_storageImages',
}

export const pageItemActionTypes = {
  qAndAManager: 'qAndAManager',
  ratingManager: 'ratingManager',
  questionsAndAnswers: 'questionsAndAnswers',
  qrCode: 'qrCode',
  ticketing: 'ticketing',
  videoConferencing: 'videoConferencing',
}

export const appUserPermissionTypes = {
  imageUpload: 'imageUpload',
  itemLinking: 'itemLinking',
  requestAccess: 'requestAccess',
  rating: 'rating',
  userEmailSignInLinks: 'userEmailSignInLinks',
}

export const settingsActionTypes = {
  backupAllSettings: 'backupAllSettings',
  backupSettings: 'backupSettings',
  baseForms: 'baseForms',
  baseSettings: 'baseSettings',
  commitActiveSettings: 'commitActiveSettings',
  convertSettingsToSeparate: 'convertSettings',
  copyEvent: 'copyEvent',
  copyViewItemSettingsFromDatabase: 'copyViewItemSettingsFromDatabase',
  copyViewItemSettingsToViews: 'copyViewItemSettingsToViews',
  createClient: 'createClient',
  createEvent: 'createEvent',
  createHelpDocument: 'createHelpDocument',
  currentSettings: 'currentSettings',
  deleteBucket: 'deleteBucket',
  deleteClient: 'deleteClient',
  deleteEvent: 'deleteEvent',
  duplicateGoogleSheets: 'duplicateGoogleSheets',
  fixAllSettings: 'fixAllSettings',
  fixSettings: 'fixSettings',
  getThemesFromParent: 'getThemesFromParent',
  lockData: 'lockData',
  printHelp: 'printHelp',
  pushClientToProduction: 'pushClientToProduction',
  pushEventToProduction: 'pushEventToProduction',
  recreateEvent: 'recreateEvent',
  replaceExistingAndUpdateDataFromGoogleSheets: 'replaceExistingAndUpdateDataFromGoogleSheets',
  restoreSettingsFromBackup: 'restoreSettingsFromBackup',
  restoreSettingsFromGoogleSheets: 'restoreSettingsFromGoogleSheets',
  restoreSettingsFromPaste: 'restoreSettingsFromPaste',
  restoreSettingsFromRegistration: 'restoreSettingsFromRegistration',
  transferDataToProduction: 'transferDataToProduction',
  transferEventToProduction: 'transferEventToProduction',
  transferSettings: 'transferSettings',
  transferSettingsToProduction: 'transferSettingsToProduction',
  updateAllPageItems: 'updateAllPageItems',
  updateDataByType: 'updateDataByType',
  updateDataFromGoogleData: 'updateDataFromGoogleData',
  updateDataFromGoogleSheets: 'updateDataFromGoogleSheets',
  updateDataLists: 'updateDataLists',
  updateEventStatus: 'updateEventStatus',
  updateSettings: 'updateSettings',
  updateSettingsByType: 'updateSettingsByType',
  updateSettingsFromGoogleSheets: 'updateSettingsFromGoogleSheets',
  // fixData: 'fixData',
}

/**
 * enum list including (dataManagementTypes, dataModificationTypes, pageItemActionTypes, appUserPermissionTypes)
 */
export const itemActionTypes = {
  appUserInfo: 'appUserInfo',
  assignPageItemAccess: 'assignPageItemAccess',
  clipboard: 'clipboard',
  connectToAppUser: 'connectToAppUser',
  dataLinking_data: 'dataLinking_data',
  dataManagement: 'dataManagement',
  dataModifications: 'dataModifications',
  edit: 'edit',
  emailAuth: 'emailAuth',
  geoMapList: 'geoMapList',
  imageMapping: 'imageMapping',
  notifications: 'notifications',
  openDatabase: 'openDatabase',
  phoneAuth: 'phoneAuth',
  refreshGoogleSheets: 'refreshGoogleSheets',
  save: 'save',
  search: 'search',
  showItemCount: 'showItemCount',
  signInAs: 'signInAs',
  signInDirectEmail: 'signInDirectEmail',
  signInDirectPhone: 'signInDirectPhone',
  sorting: 'sorting',
  subAction: 'subAction',
  upload_bulkImage: 'upload_bulkImage',
  userNotification: 'userNotification',
  viewAccessRequests: 'viewAccessRequests',
  viewAppUserAuthorizations: 'viewAppUserAuthorizations',
  voiceSearch: 'voiceSearch',
  ...dataManagementTypes,
  ...dataModificationTypes,
  ...pageItemActionTypes,
  ...appUserPermissionTypes,
}

export const itemActionIcons = {
  activate: 'bolt',
  add: 'add',
  assignPageItemAccess: 'users',
  backupData: 'save',
  clipboard: 'clipboard outline',
  convertArrays: 'code',
  convertToDocument: 'wizard',
  convertToParentKeys: 'database',
  connections: 'linkify',
  connectToAppUser: 'linkify',
  createGlobalData: 'wizard',
  createFilter: 'filter',
  createTopic: 'target',
  createList: 'list',
  googleMap: 'map',
  dataModifications: 'unordered list',
  dataManagement: 'unordered list',
  delete: 'remove circle',
  dataOptions: 'options',
  edit: 'edit',
  emailAuth: 'mail',
  // favorite: 'star',
  googleSheetLink: 'google',
  googleSheetUpdate: 'google',
  imageMapping: 'map outline',
  images: 'image outline',
  linking: 'linkify',
  lockData: 'lock',
  notifications: 'alarm',
  notificationSettings: 'alarm',
  phoneAuth: 'mail',
  questionsAndAnswers: 'question',
  qrCode: 'qrcode',
  rating: 'star outline',
  refreshGoogleSheets: 'refresh',
  requestAccess: 'handshake outline',
  search: 'search',
  signInAs: 'clone outline',
  signInDirectEmail: 'sign in',
  signInDirectPhone: 'sign in',
  sorting: 'sort numeric down',
  subAction: 'bolt',
  ticketing: 'ticket alternate',
  updateDataRelationships: 'handshake',
  updateParentKeys: 'key',
  userEmailSignInLinks: 'mail',
  userNotification: 'bell',
  videoConferencing: 'video',
  viewAccessRequest: 'handshake outline',
  networking: 'handshake outline',
  gamification: 'gamepad',
}

export const getDataUpdateType = (dataModificationType) => {
  switch (dataModificationType) {
    case dataModificationTypes.add:
      return gEnums.dataUpdateTypes.addData
    case dataModificationTypes.edit:
      return gEnums.dataUpdateTypes.updateDoc
    default:
      return dataModificationType
  }
}